export default __webpack_public_path__ + "static/media/email.2e30b3b0.png";